module.exports = __webpack_public_path__ + "img/teamExperience.00677f8b.jpg";